
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import styled from 'styled-components';
import Page from 'shared/components/Page';
import useTranslation from 'shared/hooks/useTranslation';
import Head from 'next/head';
import Image from 'next/image';
const Header = styled.h1 `
  margin: 0 auto;
  padding: 0 0 0.8rem 0;
  text-align: center;
  font-size: 2.8rem;
  width: 100%;

  ${({ theme }) => theme.MEDIA.MD} {
    padding: 3.2rem 0.8rem 0 0.8rem;
    margin: 2.4rem auto 6.4rem auto;
  }
`;
const Container = styled.div `
  overflow: hidden;
  padding-bottom: 8rem;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  min-height: 45vh;
`;
const ReviewContainer = styled.div `
  padding-top: 2.4rem;
  background-color: white;
  width: 100%;
`;
const ImageWrapper = styled.div `
  position: absolute;
  width: 100%;
  height: auto;
  top: 2.4rem;
  left: 0;
  z-index: -1;
`;
const ImageWrapperRound = styled.div `
  position: absolute;
  width: 100%;
  max-width: 152rem;
  margin: 0.8rem auto;
  height: auto;
  display: flex;
  justify-content: flex-end;
  z-index: -1;
`;
const ImageWrapperRoundBig = styled(ImageWrapperRound) `
  margin: 0;
  padding-top: 60%;
  justify-content: flex-start;
`;
function OurReviewsPage(): JSX.Element {
    const { t, lang } = useTranslation('common');
    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://trustmate.io/api/widget/932d3770-6c3a-4594-8a6c-e5a4af52b5ce/script?language=${lang}`;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, [lang]);
    return (<Page>
      <Head>
        <title>{t('titleTag')}</title>
      </Head>
      <main>
        <Container>
          <ImageWrapper>
            <Image src="/img/shared/rec-round-shape.png" alt="" width={1288} height={862} lazyBoundary="1000px"/>
          </ImageWrapper>
          <Header>{t('customerReviews')}</Header>
          <ReviewContainer>
            <div id="932d3770-6c3a-4594-8a6c-e5a4af52b5ce"/>
          </ReviewContainer>
          <ImageWrapperRound>
            <Image src="/img/shared/round-small.png" alt="" width={497} height={497} lazyBoundary="1000px"/>
          </ImageWrapperRound>
          <ImageWrapperRoundBig>
            <Image src="/img/shared/round-small.png" alt="" width={497} height={497} lazyBoundary="1000px"/>
          </ImageWrapperRoundBig>
        </Container>
      </main>
    </Page>);
}
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default OurReviewsPage;

    async function __Next_Translate__getStaticProps__197e4b1fd9c__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/our-reviews',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197e4b1fd9c__ as getStaticProps }
  